// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3c4d4","options":"AnswerScale_options__19MVQ","selected":"AnswerScale_selected__74_ma"};